import {Platform} from 'react-native';

import {desktopMenuHeight, desktopCollapsedMenuHeight} from '../../theme/helpers';
import {useStyles} from '../../hooks/styles';
import {VisImpStatus} from '../../models/visuallyImpairedSettings';

const maxMenuContentWidth = 1440;
const headerContentTopHeight = 67;
const transition = Platform.OS === 'web' ? {transition: '0.4s'} : undefined;

export const GetStyles = (visuallyImpaired: VisImpStatus) => {
  return useStyles(({theme}) => ({
    menu: {
      ...theme.menu.container,
      ...transition,
      flexDirection: 'row',
      alignItems: 'center',
      flexGrow: 1,
    },
    menuFullSize: {
      paddingBottom: 16,
      height: desktopMenuHeight - headerContentTopHeight,
    },
    menuCollapsed: {
      paddingTop: 4,
      height: headerContentTopHeight,
    },
    menuCollapsibleItems: {
      flexDirection: 'row',
    },
    link: theme.menu.link,
    activeLink: theme.menu.activeLink,
    header: {
      ...theme.header.container,
      ...transition,
      flexDirection: 'row',
      justifyContent: 'center',
      width: '100%',
    },
    headerShadow: {
      shadowColor: theme.color.primaryBlackColor,
      shadowOpacity: 0.14,
      shadowOffset: {width: 0, height: 2},
      shadowRadius: 4,
    },
    headerLogo: {
      position: 'relative',
      zIndex: 5,
      alignItems: 'center',
      backgroundColor: theme.color.backgroundMenuColor,
      height: desktopCollapsedMenuHeight,
      alignSelf: 'flex-start',
    },
    headerLink: {
      ...transition,
      zIndex: 2,
    },
    headerLinkFull: {
      marginTop: 27,
      marginLeft: 20,
      marginRight: 20,
    },
    headerLinkCollapsed: {
      marginTop: -10,
      marginLeft: 29,
      marginRight: 10,
    },
    headerContent: {
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
    },
    headerContentTop: {
      ...transition,
      flexDirection: 'row',
      alignItems: 'center',
      zIndex: 2,
    },
    headerContentTopFullSize: {
      bottom: 0,
      height: headerContentTopHeight,
    },
    headerContentTopCollapsed: {
      bottom: headerContentTopHeight,
      height: 0,
    },
    subContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      maxWidth: maxMenuContentWidth,
      width: '100%',
    },
    border: {
      ...transition,
      position: 'absolute',
      width: '100%',
      height: 0,
      borderBottomWidth: 1,
      borderBottomColor: theme.header.topLineColor,
      borderStyle: 'solid',
    },
    pixelPerfectUserInfo: {
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: 3,
      marginLeft: 'auto',
      alignItems: 'center',
    },
    iconContainer: {
      flexDirection: 'row',
      marginHorizontal: 'auto',
    },
    lastLink: {
      marginRight: visuallyImpaired ? 'auto' : 0,
    },
  }));
};
